import {
  type Branding,
  ChatAvailability,
  ClientName,
  type ContactSupportConfig,
  FlightShopCardType,
  FlightShopDefaultSort,
  I18nNamespace,
} from "@hopper-b2b/types";
import { DateTimeFormatStyle, formatDateTime } from "@hopper-i18n/formatter";

const contactSupport: ContactSupportConfig = {
  chatAvailability: ChatAvailability.None,
  displaySupportNumber: "+44 800-032-1196",
  supportNumber: "+448000321196",
  displayIntlSupportNumber: "+44 20-3886-6403",
  intlSupportNumber: "+442038866403",
};

const branding: Branding = {
  default: "en-GB",
  contactSupport,
  merchantPayments: "",
  clientName: ClientName.UBER,
  currencies: [
    {
      locale: "en-GB",
      code: "GBP",
      symbol: "£",
    },
  ],
  supportedLanguages: [
    {
      key: "es",
      name: "Español",
      label: "Español",
    },
    { key: "en", name: "English", label: "English" },
    { key: "en-GB", name: "English", label: "English" },
  ],
  flightShopCardType: FlightShopCardType.MINI,
  flightShopDefaultSort: FlightShopDefaultSort.TagsThenPrice,
  adaChat: {
    answerIds: {
      delayOrMissedConnection: "6418b6f2d98bdd47409e0705",
    },
  },
  [I18nNamespace.translation]: {
    en: {
      portalName: "Uber with Hopper",
      urls: {
        termsAndConditions: "",
        privacyPolicy: "",
        disruptionTerms:
          "https://www.uber.com/legal/en/document/?name=uber-travel---terms-and-conditions---flights-and-hotels&country=great-britain&lang=en",
        priceFreezeTerms:
          "https://www.uber.com/legal/en/document/?name=uber-travel---terms-and-conditions---flights-and-hotels&country=great-britain&lang=en",
        missedConnectionTerms:
          "https://www.uber.com/legal/en/document/?name=uber-travel---terms-and-conditions---flights-and-hotels&country=great-britain&lang=en",
      },
      preferredCountryCode: "GB",
      preferredAreaCode: "+44",
      calendarMonthFormat: "MMMM",
      timeFormat: "h:mm A",
      customDateTimeFormats: {
        calendarDay: (date: Date) =>
          formatDateTime(
            new Date(date),
            "en",
            DateTimeFormatStyle.Custom({
              weekday: "short",
            })
          ).slice(0, 2),
      },
    },
    "en-GB": {
      portalName: "Uber with Hopper",
      urls: {
        termsAndConditions: "",
        privacyPolicy: "",
        disruptionTerms:
          "https://www.uber.com/legal/en/document/?name=uber-travel---terms-and-conditions---flights-and-hotels&country=great-britain&lang=en",
        priceFreezeTerms:
          "https://www.uber.com/legal/en/document/?name=uber-travel---terms-and-conditions---flights-and-hotels&country=great-britain&lang=en",
        missedConnectionTerms:
          "https://www.uber.com/legal/en/document/?name=uber-travel---terms-and-conditions---flights-and-hotels&country=great-britain&lang=en",
      },
      preferredCountryCode: "GB",
      preferredAreaCode: "+44",
      calendarMonthFormat: "MMMM",
      timeFormat: "h:mm A",
      customDateTimeFormats: {
        calendarDay: (date: Date) =>
          formatDateTime(
            new Date(date),
            "en",
            DateTimeFormatStyle.Custom({
              weekday: "short",
            })
          ).slice(0, 2),
      },
    },
    es: {
      portalName: "Uber con Hopper",
      urls: {
        termsAndConditions: "",
        privacyPolicy: "",
        disruptionTerms:
          "https://www.uber.com/legal/en/document/?name=uber-travel---terms-and-conditions---flights-and-hotels&country=great-britain&lang=en",
        priceFreezeTerms:
          "https://www.uber.com/legal/en/document/?name=uber-travel---terms-and-conditions---flights-and-hotels&country=great-britain&lang=en",
        missedConnectionTerms:
          "https://www.uber.com/legal/en/document/?name=uber-travel---terms-and-conditions---flights-and-hotels&country=great-britain&lang=en",
      },
      preferredCountryCode: "GB",
      preferredAreaCode: "+44",
      calendarMonthFormat: "MMMM",
      timeFormat: "h:mm A",
      customDateTimeFormats: {
        calendarDay: (date: Date) =>
          formatDateTime(
            new Date(date),
            "es",
            DateTimeFormatStyle.Custom({
              weekday: "short",
            })
          ).slice(0, 2),
      },
    },
  },
};

// We need to have both en-GB and en in branding object
// otherwise the I18nContext hooks does not recognize these languages as supported
// The contents are the same for all "en" languages for now
branding[I18nNamespace.translation]["en-GB"] =
  branding[I18nNamespace.translation].en;

export { branding };
